// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph_paragraph___avg2"};